webpackJsonp([261153568727339],{

/***/ 116:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Collaborator = function (_React$Component) {
	  _inherits(Collaborator, _React$Component);
	
	  function Collaborator() {
	    _classCallCheck(this, Collaborator);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Collaborator.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      { className: "collaborator-container col-xs-6 col-sm-4 col-md-4 col-lg-3 col-xl-3" },
	      _react2.default.createElement(
	        'div',
	        { className: 'collaborator' },
	        _react2.default.createElement(
	          'a',
	          { href: this.props.url, target: '_blank' },
	          _react2.default.createElement('img', { src: this.props.logo, alt: this.props.name })
	        )
	      )
	    );
	  };
	
	  return Collaborator;
	}(_react2.default.Component);
	
	Collaborator.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  logo: _propTypes2.default.string.isRequired,
	  sponsor: _propTypes2.default.bool.isRequired,
	  url: _propTypes2.default.string.isRequired
	};
	Collaborator.defaultProps = {
	  name: "Georgia Tech",
	  logo: "",
	  sponsor: false,
	  url: "#"
	};
	exports.default = Collaborator;
	module.exports = exports['default'];

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/publications.20f5f89b.jpg";

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(24);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _publications = __webpack_require__(160);
	
	var _publications2 = _interopRequireDefault(_publications);
	
	var _collaborator = __webpack_require__(86);
	
	var _collaborator2 = _interopRequireDefault(_collaborator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	
	  var sponsors = [];
	  var collaborators = [];
	
	  data.allContentfulCollaborators.edges.map(function (_ref2) {
	    var node = _ref2.node;
	
	    if (node.sponsor) {
	      sponsors.push(node);
	    } else {
	      collaborators.push(node);
	    }
	  });
	
	  var sponsorImages = sponsors.map(function (sponsor, index) {
	    return _react2.default.createElement(_collaborator2.default, { name: sponsor.name, logo: sponsor.logo.file.url, sponsor: true, url: sponsor.link });
	  });
	
	  var collaboratorImages = collaborators.map(function (collab, index) {
	    return _react2.default.createElement(_collaborator2.default, { name: collab.name, logo: collab.logo.file.url, sponsor: false, url: collab.link });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'team' },
	    _react2.default.createElement(_header2.default, {
	      image: _publications2.default,
	      title: "NANOTECH LAB | YUSHIN GROUP",
	      subtitle: "Collaborators and Sponsors"
	    }),
	    _react2.default.createElement(
	      'section',
	      { className: "grey" },
	      _react2.default.createElement(
	        'div',
	        { className: "container sponsors" },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10' },
	            'Sponsors'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: "row" },
	          sponsorImages
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: "container collaborators" },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'col-xs-12 col-sm-12 col-lg-offset-1 col-lg-10 col-xl-10' },
	            'Collaborators'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: "row" },
	          collaboratorImages
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-collaborators-js-4cd950ef81a664c8bfcc.js